import { FaWhatsapp, FaInstagram, FaFacebook, FaLinkedin } from "react-icons/fa";

function SocialFloat() {
  return (
    <div style={styles.container}>
      <a
        href="https://wa.me/918107215810"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon"
        style={{ ...styles.icon, backgroundColor: '#25D366' }}
        title="WhatsApp"
      >
        <FaWhatsapp size={20} />
      </a>

      <a
        href="https://www.facebook.com/yourpage"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon"
        style={{ ...styles.icon, backgroundColor: '#1877F2' }}
        title="Facebook"
      >
        <FaFacebook size={20} />
      </a>

      <a
        href="https://www.instagram.com/yourprofile"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon"
        style={{ ...styles.icon, backgroundColor: '#E1306C' }}
        title="Instagram"
      >
        <FaInstagram size={20} />
      </a>

      <a
        href="https://www.linkedin.com/in/yourprofile"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon"
        style={{ ...styles.icon, backgroundColor: '#0e76a8' }}
        title="LinkedIn"
      >
        <FaLinkedin size={20} />
      </a>
    </div>
  );
}

const styles = {
  container: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    zIndex: 999,
  },
  icon: {
    color: "#fff",
    padding: "12px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
};

export default SocialFloat;
